<template>
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div v-else-if="is_no_records == 1">
      <GlobalEmptyRecord RouteName="ProductCreate">
        <template slot="title">
          <h2>Shanki Product</h2>
        </template>
        <template slot="content">
          <span style="color: gray">Find Products for Customers</span>
        </template>
        <template slot="page">New Product</template>
        <template slot="importbutton">
          <router-link :to="{ name: 'ProductImport' }">
            <b-button variant="light" size="sm" class="mb-xs mr-xs" title="Import Products">
              <span class="fa fa-upload"></span>
            </b-button>
          </router-link>
        </template>
      </GlobalEmptyRecord>
    </div>
    <div class="start-page" v-else style="margin-top: -10px !important">
      <template v-if="CheckedCount == 0">
        <b-row class="px-pad border-bottom" style="height: 42px">
          <b-col cols="8" class="px-0">
            <!-- custom filter dropdown -->
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              class="index-filter-heading"
              size="sm"
              dropdown
              :text="filter_name"
            >
              <div class="dropdownitem-list">
                <b-dropdown-item
                  :class="{ filter_dropdown: true }"
                  :to="{
                  name: 'Product',
                  query: {
                    page: 1,
                    show: 10,
                    search: '',
                    status: status,
                    sort: sort,
                    label: label,
                    status: item.status_id,
                  },
                }"
                  v-for="item in filter_list"
                  :key="item.status_id"
                  v-if="item.status_name != filter_name"
                >{{ item.status_name }}</b-dropdown-item>
              </div>
              <b-dropdown-divider />
              <router-link
                class="event-link dropdown-item"
                :to="{
                name: 'FilterCreate',
                params: {
                  title: 'Product',
                  module: 'products',
                  call: 'fetchProductFilterDetails',
                  route:'products'
                },
              }"
              >Add Custom Filter</router-link>
            </b-dropdown>
            <!-- edit button for custom filter dropdown -->
            <router-link
              class="event-link"
              v-if="status >= 100"
              :to="{
              name: 'FilterUpdate',
              params: {
                id: getPresentValue(filter_list, 'status_name', filter_name),
                title: 'Product',
                module: 'products',
                call: 'fetchProductFilterDetails',
                route:'products'
              },
            }"
            >
              <b-button size="xs" style="position: relative; bottom: 4px" variant="light">
                <i class="la la-edit la-lg"></i>
              </b-button>
            </router-link>
          </b-col>
          <b-col cols="4" class="text-right px-0">
            <router-link
              :to="{ name: 'ProductCreate' }"
              v-if="RoutePermission(true, 'ProductCreate', '', '', '')"
            >
              <b-button variant="primary" size="sm" class="mr-2">New Product</b-button>
            </router-link>
            <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()">
              <i class="la la-refresh la-lg"></i>
            </b-button>
            <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
              <template slot="button-content">
                <i class="la la-navicon la-lg"></i>
              </template>
              <b-dropdown-item v-if="RoutePermission(true, 'ProductCreate', '', '', '')">
                <router-link :to="{ name: 'ProductImport' }" class="text-decoration-none text-dark">
                  <span class="no_caret_import la la-upload mr-3"></span>Import
                  Products
                </router-link>
              </b-dropdown-item>
              <template v-if="RoutePermission(false,'','','settings','export')">
                <b-dropdown-item @click="exportModal()">
                  <span class="no_caret_import la la-download mr-3"></span>Export
                  Products
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
              </template>
              <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
              <div class="dropdownitem-block">
                <li class="ml-3">
                  <b-form-checkbox name="pdt_unit" v-model="pdt_unit" value="1">Unit</b-form-checkbox>
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="pdt_intra_tax_id"
                    v-model="pdt_intra_tax_id"
                    value="2"
                  >GST percent</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="pdt_inter_tax_id"
                    v-model="pdt_inter_tax_id"
                    value="3"
                  >IGST percent</b-form-checkbox>
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox name="sales_account" v-model="sales_account" value="5">Account</b-form-checkbox>
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox name="pdt_desc" v-model="pdt_desc" value="8">Description</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="created_at" v-model="created_at" value="17">Created Time</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2 pb-2">
                  <b-form-checkbox name="updated_at" v-model="updated_at" value="18">Updated Time</b-form-checkbox>
                </li>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" class="px-0">
          <!--  row for bulk delete option and acitve and inactive if atleast one checkbox is selected in the table -->
          <b-row style="height: 42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
            <b-col xl="6" lg="6" md="6" sm="6" xs="6">
              <b-button
                size="sm"
                v-b-modal.pdtdelete
                @click="deletemodal"
                variant="light"
                class="text-left"
                :disabled="!RoutePermission(false, '', 'invoice', 'product', 'delete')"
              >
                <i
                  class="glyphicon glyphicon-trash"
                  v-b-tooltip="!RoutePermission(false,'','invoice','product','delete')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
                ></i>
              </b-button>
              <b-button
                size="sm"
                @click="(statusPage = 'active'), (modalPage = 'status')"
                v-b-modal.statusPage
                variant="light"
                class="text-left ml-2"
                :disabled="!RoutePermission(false, '', 'invoice', 'product', 'update')"
              >
                <span
                  v-b-tooltip="!RoutePermission(false,'','invoice','product','update')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
                >Active</span>
              </b-button>
              <b-button
                size="sm"
                @click="(statusPage = 'inactive'), (modalPage = 'status')"
                v-b-modal.statusPage
                variant="light"
                class="text-left ml-2"
                :disabled="!RoutePermission(false, '', 'invoice', 'product', 'update')"
              >
                <span
                  v-b-tooltip="!RoutePermission(false,'','invoice','product','update')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
                >Inactive</span>
              </b-button>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6">
              <i
                v-on:click="
                checkAll({
                  target: {
                    checked: false,
                  },
                }),
                  (CheckedCount = 0),
                  (checkboxes1[0] = false)
              "
                class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
              ></i>
            </b-col>
          </b-row>
          <b-alert
            class="alert-transparent alert-shade mx-mar mt-3"
            :show="this.$route.params.search == '' ? false : true"
          >
            <router-link
              class="text-dark float-right"
              :to="{
              name: 'Product',
              query: {
                page: page,
                show: count,
                search: '',
                sort: sort,
                label: label,
                custom: custom,
              },
            }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span class="fw-semi-bold">Product Name / Product HSN / Product SKU:</span>
              {{ this.$route.query.search }}
            </p>
          </b-alert>
          <div
            :class="
            this.$route.params.search == ''
              ? 'table-responsive'
              : 'table_search'
          "
            id="scrollCol"
          >
            <table class="table table-hover index-table">
              <thead>
                <tr>
                  <th style="width: 54px !important">
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        id="checkboxall"
                        v-model="checkboxes1[0]"
                        @change="(event) => checkAll(event)"
                      />
                      <label for="checkboxall" />
                    </div>
                  </th>
                  <!-- <th style="width:65px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Product',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pdt_code',custom:custom } }"
                  >
                    ID
                    <small class="text-muted" v-if="label == 'pdt_code'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                  </th>-->
                  <th style="min-width: 230px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'pdt_name',
                        custom: custom,
                      },
                    }"
                    >
                      Product Name
                      <small class="text-muted" v-if="label == 'pdt_name'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 50px !important" v-if="pdt_unit == 1">Unit</th>
                  <th style="min-width: 120px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'pdt_hsn',
                        custom: custom,
                      },
                    }"
                    >
                      Hsn Code
                      <small class="text-muted" v-if="label == 'pdt_hsn'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'pdt_sku',
                        custom: custom,
                      },
                    }"
                    >
                      SKU No.
                      <small class="text-muted" v-if="label == 'pdt_sku'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 120px !important" v-if="pdt_intra_tax_id == 2">GST Percent</th>
                  <th style="min-width: 120px !important" v-if="pdt_inter_tax_id == 3">IGST Percent</th>
                  <th class="text-right" style="min-width: 140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'selling_price',
                        custom: custom,
                      },
                    }"
                    >
                      Sale Price
                      <small class="text-muted" v-if="label == 'selling_price'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="min-width: 140px !important" v-if="sales_account == 5">Sales Account</th>

                  <th style="min-width: 180px !important" v-if="pdt_desc == 8">Product Description</th>
                  <th style="min-width:300px !important" v-if="created_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'Product',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'created_at',custom:custom } }"
                    >
                      Created Time
                      <small class="text-muted" v-if="label == 'created_at'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:300px !important" v-if="updated_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'Product',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'updated_at',custom:custom } }"
                    >
                      Updated time
                      <small class="text-muted" v-if="label == 'updated_at'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 30px !important" class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="7" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(list, index) in lists" :key="list.id">
                    <td>
                      <div class="abc-checkbox index-checkbox text-left">
                        <input
                          type="checkbox"
                          v-model="checkboxes1[index + 1]"
                          :id="'checkbox' + (index + 1)"
                          :true-value="list.pdt_id"
                          :value="list.pdt_id"
                          @change="
                          (event) =>
                            changeCheck(event, 'checkboxes1', index + 1)
                        "
                        />
                        <label :for="'checkbox' + (index + 1)" />
                      </div>
                    </td>
                    <td
                      style="max-width: 230px !important"
                      v-if="RoutePermission(true, 'ProductView', '', '', '')"
                    >
                      <router-link
                        class="event-link"
                        :to="{ name: 'ProductView', params: { id: list.pdt_id } }"
                      >
                        <span class="text theme-text-color btn-link">
                          {{
                          list.pdt_name
                          }}
                        </span>
                      </router-link>
                    </td>
                    <td v-else>
                      <span class="text theme-text-color btn-link">
                        {{
                        list.pdt_name
                        }}
                      </span>
                    </td>

                    <td v-if="pdt_unit == 1">{{ list.pdt_unit }}</td>
                    <td>{{ list.pdt_hsn }}</td>
                    <td style="width: 140px !important">
                      <span class="text">{{ list.pdt_sku }}</span>
                    </td>
                    <td v-if="pdt_intra_tax_id == 2">{{ list.pdt_intra_tax_id }}</td>
                    <td v-if="pdt_inter_tax_id == 3">{{ list.pdt_inter_tax_id }}</td>
                    <td class="text-right">
                      {{
                      orgCurrencySymbol + " " + parseFloat(list.selling_price)
                      }}
                    </td>

                    <td v-if="sales_account == 5">{{ list.sales_account }}</td>

                    <td v-if="pdt_desc == 8" style="width: 180px !important">
                      <span class="text">{{ list.pdt_desc }}</span>
                    </td>
                    <td v-if="created_at">
                      <span class="text">{{ displayDateTime(list.created_at) }}</span>
                    </td>
                    <td v-if="updated_at">
                      <span class="text">{{ displayDateTime(list.updated_at) }}</span>
                    </td>
                    <td class="text-right">
                      <router-link
                        v-if="RoutePermission(true, 'ProductUpdate', '', '', '')"
                        class="event-link theme-text-color text-decoration-none"
                        :to="{
                        name: 'ProductUpdate',
                        params: { id: list.pdt_id },
                        query:{page_from:'index'}
                      }"
                      >
                        <i class="la la-edit la-lg theme-text-color table-hover-visible"></i>
                      </router-link>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="lists.length > 0"
        style="width: 100%; position: absolute; border-top: 1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="5" md="6" lg="6" sm="8" cols="8" class="mt-2 pt-1 px-0">
          <nav class="float-left">
            <p>
              Showing {{ total_count != 0 ? (page - 1) * count + 1 : 0 }} to
              {{ (page - 1) * show + lists.length }} of {{ total_count }} entries
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  size="xs"
                  :text="count"
                  left
                >
                  <router-link
                    :to="{
                    name: 'Product',
                    query: {
                      page: 1,
                      show: 10,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{
                    name: 'Product',
                    query: {
                      page: 1,
                      show: 25,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{
                    name: 'Product',
                    query: {
                      page: 1,
                      show: 50,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                  </router-link>
                </b-dropdown>
              </span>
              rows per page
            </p>
          </nav>
        </b-col>
        <b-col
          xl="2"
          md="2"
          lg="2"
          sm="4"
          cols="4"
          style="text-align: center"
          class="mt-2 pt-1 px-0"
        >
          <div v-if="arrow">
            <a @click="left('#scrollCol')" class="mr-2">
              <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
            </a>
            <a @click="right('#scrollCol')">
              <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
            </a>
          </div>
        </b-col>
        <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
          <template v-if="total_count > show">
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page - 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                    name: 'Product',
                    query: {
                      page: 1,
                      show: count,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  >First</router-link>
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page - 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Previous</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page + 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Next</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                    name: 'Product',
                    query: {
                      page: Math.ceil(total_count / count),
                      show: count,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  >Last</router-link>
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                      name: 'Product',
                      query: {
                        page: page + 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </template>
        </b-col>
      </b-row>
      <!--  bulk delete modal -->
      <DeleteRecord
        v-on:setDelete="getDelete"
        :value="value"
        module="products"
        content="Are you sure you want to delete this products ?"
      ></DeleteRecord>
      <LogRecord :message="logrecords"></LogRecord>
      <b-modal
        id="statusPage"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
        title="Status"
        @ok="handledelete"
        :ok-disabled="submitted"
      >
        <p>Are you sure you want to {{ statusPage }} the selected products ?</p>
      </b-modal>
      <GlobalExportModal
        v-if="export_modal"
        :data="export_data"
        :columns="export_xl"
        :file_name="'Products'"
        @downloaded="export_modal = false"
      />
    </div>
  </div>
</template>
<script>
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import $ from "jquery";
import { notificationMixin } from "@/mixins/notification";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
function getPageProducts(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status =
    routeTo.query.status || store.state.products.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";

  store
    .dispatch("products/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable, formatDate],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number]
  },
  name: "Product",
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound
  },
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      logrecords: "", // to show log of popup funcitons
      value: [],
      export_xl: {
        "Product Type": "pdt_type",
        "Product Name": "pdt_name",
        "Product legacy id": "pdt_legacy_id",
        Status: "pdt_status",
        Unit: "pdt_unit",
        SKU: "pdt_sku",
        "HSN/SAC": "pdt_hsn",
        "Selling Price": "pdt_sal_price",
        Description: "pdt_desc",
        "Sales Account": "sales_account",
        "Intra State Tax Rate Name": "pdt_tax_name",
        "Intra State Tax Rate": "pdt_tax_id",
        "Inter State Tax Rate Name": "pdt_inter_tax_name",
        "Inter State Tax Rate": "pdt_inter_tax_id",
        "Exemption Reason": "exempt_reason",
        "Product tag": "pdt_tags",
        "Inclusive of tax": "pdt_tax_type",
        "Is Taxable": "is_taxable",
        "Created Time": "created_at",
        "Updated Time": "updated_at"
      },
      pdt_upc: "",
      inv_account: "",
      pdt_wgt: "",
      pdt_unit: "",
      cost_price: "",
      sales_account: "",
      purchase_account: "",
      pdt_desc: "",
      sales_desc: "",
      purchase_desc: "",
      stock_on_hand: "",
      reorder_level: "",
      pdt_intra_tax_id: "",
      pdt_inter_tax_id: "",
      created_at: "",
      updated_at: "",
      modalPage: "",
      statusPage: "",
      CheckedCount: 0,
      CheckedPdtIds: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      checkboxes1: [],
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
      check_index: [],
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  methods: {
    //refresh List
    getrefreshList() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("products/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })

        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);

          this.$route.params.sort = sort;
          await this.$router.push({
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              page: this.page,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          });
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      // this.$root.$emit("bv::show::modal", "exportdata");
    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    //  detelted record details
    getDelete(ev) {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;

      store
        .dispatch("products/fetchLists", {
          from_date: this.from_date,
          to_date: this.to_date,
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          update: update_status
        })
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);

          this.$route.params.sort = sort;
          await this.$router.push({
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              page: this.page,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          });
        });

      if (this.status_code == 200) {
        this.logrecords =
          this.message.message.length == 0
            ? this.message.success
            : this.message.message;
        this.$root.$emit("bv::show::modal", "loglist");
      } else {
         window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
          showCloseButton: true
        });
      }
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("products/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
          if (this.status_code != 200) {
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true
            });
          } else {
            this.$root.$emit("bv::show::modal", "exportdata");
            return this.export;
          }
        });

      return response;
    },

    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    handledelete() {
      this.submitted = true;
      var pdt_ids = this.checkboxes1;
      pdt_ids = pdt_ids.filter(item => item !== false);
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const sort = this.$route.query.sort || "";
      const label = this.$route.query.label || "";
      var data, url;
      if (this.modalPage == "delete") {
        url = "pdtdelete";
        data = JSON.stringify({
          del_status: pdt_ids
        });
      } else if (this.modalPage == "status") {
        url = "pdtstatus";
        data = JSON.stringify({
          name: this.statusPage,
          status: pdt_ids
        });
      }

      store.dispatch("products/" + url, data).then(response => {
        this.submitted = false;
        this.CheckedCount = 0;
        this.checkboxes1 = [];

        store
          .dispatch("products/fetchLists", {
            page: currentPage,
            show: show,
            search: search,
            status: status,
            sort: sort,
            label: label
          })
          .then(() => {
            this.$route.params.page = currentPage;
            this.$route.params.show = show;
            this.$route.params.search = search;
            this.$route.params.status = status;
            this.$route.params.sort = sort;
            this.$route.params.label = label;
          });

        if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.message,
            type: response.data.type,
            showCloseButton: true
          });
        }
      });
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;
      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.pdt_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var pdt_ids = this.checkboxes1;
      pdt_ids = pdt_ids.filter(item => item !== false);
      // check all if page length matches
      if (pdt_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    }
  },
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    var temp = this;
    if (this.pdt_settings_details.custom_field.length > 0) {
      this.pdt_settings_details.custom_field.map(function(value) {
        temp.export_xl[value.label_name] = value.field_name;
      }, 0);
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
     store.state.products.index_status=store.state.settings.status_code!=404? store.state.products.index_status:""
    store.dispatch("products/fetchProductFilterDetails");
    getPageProducts(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store.state.products.index_status = "";
    getPageProducts(routeTo, next);
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
  beforeRouteLeave(to, from, next) {
    store.state.products.pdt_index_history = from.fullPath;
    store.state.products.index_status = from.params.status;
    store.state.settings.status_code=''
    next();
  },

  computed: {
    ...mapState({
      lists: state => state.products.lists,
      total_count: state => state.products.total_count,
      count: state => state.products.count,
      search_criteria: state => state.products.search_criteria,
      filter_list: state => state.products.filter_list,
      filter_name: state => state.products.filter_name,
      delete: state => state.products.delete,
      export: state => state.products.export,
      message: state => state.products.log_details,
      is_no_records: state => state.products.is_no_records, // to check for an record in the database
      status_code: state => state.products.status_code,
      status_message: state => state.products.status_message,
      status_type: state => state.products.status_type
    }),
    ...mapGetters(["orgCurrencySymbol", "pdt_settings_details"])
  }
};
</script>